import { Search } from '@mui/icons-material';
import { Grid, Button } from '@mui/material';
import { FC, SetStateAction, Dispatch } from 'react';
import { FiltersLayout, SearchField } from '../../../components';

interface IFavoriteFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setHasAppliedFilters: Dispatch<SetStateAction<boolean>>;
  hasAppliedFilters: boolean;
  setSearchValue?: (val: string) => void;
  setSearchedValue?: (val: string) => void;
  searchValue?: string;
  searchedValue?: string;
  handleSearch?: (val: string) => void;
  searchPlaceholder?: string;
}

export const FavoriteFilters: FC<IFavoriteFilters> = ({
  isLoading,
  applyFilters,
  setHasAppliedFilters,
  hasAppliedFilters,
  handleSearch,
  searchValue,
  setSearchValue,
  setSearchedValue,
  searchPlaceholder,
  searchedValue
}) => {
  return (
    <FiltersLayout>
      {handleSearch && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={handleSearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleClearSearch={() => {
              setHasAppliedFilters(false);
              setSearchedValue && setSearchedValue('');
              setSearchValue && setSearchValue('');
              applyFilters(true);
            }}
          />
        </Grid>
      )}
      <Grid item xs={12} md={5} xl={3}>
        <Button
          color="primary"
          variant="contained"
          disabled={isLoading || !searchValue}
          startIcon={<Search />}
          onClick={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
        >
          Search
        </Button>
      </Grid>
    </FiltersLayout>
  );
};
